import { useStoreContext } from 'features/store';

import { IMenuSelectionInput } from 'generated/graphql-gateway';
import { useServiceModeContext } from 'state/service-mode';

export const usePriceOrderV2Input = (menuSelections: IMenuSelectionInput[]) => {
  const { store } = useStoreContext();
  const { serviceMode } = useServiceModeContext();
  return {
    storeId: store.number,
    serviceMode,
    cart: { menuSelections },
  };
};
